/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssetService {

    /**
     * @returns string Success
     * @throws ApiError
     */
    public static getBackendv2AssetTypesAll(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/Asset/types/all',
        });
    }

    /**
     * @param clientId 
     * @param type 
     * @returns string Success
     * @throws ApiError
     */
    public static getBackendv2AssetMetadataNames(
clientId?: number,
type?: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/Asset/metadata/names',
            query: {
                'clientId': clientId,
                'type': type,
            },
        });
    }

    /**
     * @param clientId 
     * @param name 
     * @param type 
     * @returns string Success
     * @throws ApiError
     */
    public static getBackendv2AssetMetadataValues(
clientId?: number,
name?: string,
type?: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/Asset/metadata/values',
            query: {
                'clientId': clientId,
                'name': name,
                'type': type,
            },
        });
    }

    /**
     * @param name 
     * @param clientId 
     * @param type 
     * @returns string Success
     * @throws ApiError
     */
    public static getBackendv2AssetMetadataValues1(
name: string,
clientId?: number,
type?: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/Asset/metadata/{name}/values',
            path: {
                'name': name,
            },
            query: {
                'clientId': clientId,
                'type': type,
            },
        });
    }

}
